import packageConfig from '../../package.json';

export const cdnPath = 'https://utils-cdn.petsure.com.au';

export const BuildSettings = {
  cba: {
    public: {
      gtmTagId: 'GTM-NZXSJQTS',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: false
          }
        }
      }
    }
  },
  bwm: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: false
          }
        }
      }
    }
  },
  medibank: {
    public: {
      gtmTagId: 'GTM-W4K2JCD',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        },
        adobe: {
          sit: {
            enabled: true,
            scriptSrc: 'https://assets.adobedtm.com/013d73527521/2023336667a7/launch-3e53864fddaf-staging.min.js'
          },
          uat: {
            enabled: true,
            scriptSrc: 'https://assets.adobedtm.com/013d73527521/2023336667a7/launch-3e53864fddaf-staging.min.js'
          },
          preprod: {
            enabled: true,
            scriptSrc: 'https://assets.adobedtm.com/013d73527521/2023336667a7/launch-3e53864fddaf-staging.min.js'
          },
          prod: {
            enabled: true,
            scriptSrc: 'https://assets.adobedtm.com/013d73527521/2023336667a7/launch-917718a86c0f.min.js'
          }
        }
      }
    }
  },
  bupa: {
    public: {
      gtmTagId: 'GTM-5FTQSCP',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: false
          }
        }
      }
    }
  },
  piaglm3: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: false
          }
        }
      }
    }
  },
  hcf: {
    public: {
      gtmTagId: 'GTM-KVQ7KT',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: false
          }
        }
      }
    }
  },
  pinscom: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: false
          }
        }
      }
    }
  }
};

export const GetBrandLibraryVersion = (brand, site) => {
  if (BuildSettings[brand][site] && BuildSettings[brand][site].libraryVersion) {
    return BuildSettings[brand][site].libraryVersion;
  }
  const UILibraryDependency = packageConfig.dependencies['@PetSureAustralia/petsure-react-ui-library'];
  const VersionRegex = /([0-9.]+)/;
  const UILibraryVersion = UILibraryDependency.match(VersionRegex);

  if (UILibraryVersion) {
    return UILibraryVersion[0];
  }

  return new Error('Could not determine ui library version');
};

export const GetBrandBuildSettings = ({ brand, site, buildDirectory }) => {
  const entryKey = `${brand}_${site}`;
  const outputPath = `${buildDirectory}/brands/${brand}/${site}/`;
  const libraryVersion = GetBrandLibraryVersion(brand, site);
  const cssFilePath = `${cdnPath}/${libraryVersion}/brandCssFiles`;
  const { gtmTagId, analytics } = BuildSettings[brand][site];

  return {
    entryKey,
    outputPath,
    libraryVersion,
    cdnPath,
    cssFilePath,
    gtmTagId,
    analytics
  };
};
